import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { NotificationsComponent } from './notifications.component';
import { MasterLayoutsComponent } from './master-layouts/master-layouts.component';
import { AddComponent } from './add/add.component';
import { EditComponent } from './edit/edit.component';
import { TemplatesComponent } from './templates/templates.component';
import { TemplateInfoComponent } from './template-info/template-info.component';
import { EditEmailComponent } from './edit-email/edit-email.component';
import { EditSMSComponent } from './edit-sms/edit-sms.component';
import { EditTemplateComponent } from './edit-template/edit-template.component';

const routes: Routes = [
 {path :"",component:NotificationsComponent ,children:[
   {path:"MasterLayouts",component:MasterLayoutsComponent},
   {path:"Add",component:AddComponent},
   {path:"Edit/:id",component:EditComponent},
   {path:"Templates",component:TemplatesComponent},
   {path:"TemplateInfo/:id",component:TemplateInfoComponent},
   {path:"EditEmail/:id/:lang",component:EditEmailComponent},
   {path:"EditSMS/:id/:lang",component:EditSMSComponent},
   {path:"EditTemplate/:id/",component:EditTemplateComponent},
   {path:"", redirectTo: 'MasterLayouts', pathMatch: 'full'},
 ]}
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
exports: [RouterModule]
})
export class NotificationsRoutingModule { }
